import { CheckCircle, Info, TriangleAlert, X } from "lucide-react";
import { toast as sonnerToast } from "sonner";
import { cn } from "@/utils/cn";
import type { ToastVariant } from "./types";

const icons = {
  success: CheckCircle,
  error: TriangleAlert,
  information: Info,
} as const;

export interface ToastUIProps {
  id: string | number;
  title: string;
  description?: string;
  variant: ToastVariant;
  className?: string;
}

export function ToastUI({
  id,
  title,
  description,
  variant,
  className,
}: ToastUIProps) {
  const Icon = icons[variant];

  return (
    <div
      className={cn(
        "relative flex w-full flex-col rounded-3xl p-6 shadow-lg md:w-[504px]",
        "bg-brand-primary-500 text-gray-900",
        className,
      )}
    >
      <button
        type="button"
        className="absolute top-6 right-6 cursor-pointer hover:opacity-70"
        onClick={() => sonnerToast.dismiss(id)}
      >
        <X size={24} />
      </button>

      <div className="flex items-start gap-2 pr-8">
        <Icon size={24} className="shrink-0 text-gray-900" />
        <p className="text-lg font-bold">{title}</p>
      </div>

      {description && (
        <p className="mt-2 text-base opacity-90">{description}</p>
      )}
    </div>
  );
}
